import { memo } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import AirlineLogo from "app/pages/.shared/AirlineLogo";
import { convertDurationLabel } from "app/pages/.shared/ItineraryUtils";
import { ITINERARY_INFO_TYPE } from "app/constants";

import "./ItineraryView.scss";

const ItineraryView = ({ label, flightData = [] }) => {
	const timelineComponentRender = event => {
		const { type, data } = event;
		switch (type) {
			case ITINERARY_INFO_TYPE.SCHEDULE:
				return (
					<>
						<div className="itinerary-timeline__schedule">
							<div className="itinerary-timeline__time">
								<div className="take-off-time">{data.time}</div>
							</div>
							<div className={"itinerary-timeline__date"}>
								<p
									className={classNames({
										"itinerary-timeline__next-day":
											data.isNextDay ||
											(data.arrivalDaysCounter &&
												data.arrivalDaysCounter > 0),
									})}
								>
									<FormattedDate
										timeZone="UTC"
										value={new Date(data.date)}
										weekday="short"
										day="2-digit"
										month="short"
									/>
								</p>
							</div>
						</div>
						<div className="itinerary-timeline__node" />
						<div className="itinerary-timeline__airport-name">
							{data.airport} ({data.iata})
						</div>
					</>
				);
			case ITINERARY_INFO_TYPE.FLIGHT_INFO:
				return (
					<>
						<div className="itinerary-timeline__line" />
						<div
							className={classNames("itinerary-timeline__infos", {
								"itinerary-timeline__infos-flight-direct": data.isDirect,
							})}
						>
							<div className="itinerary-timeline__flight-duration">
								{convertDurationLabel(data.duration)}
							</div>
							{data.legInfo && (
								<div className="itinerary-timeline__leg-info">{data.legInfo}</div>
							)}
							<AirlineLogo airlineCode={data.airlineCode} />
							<div className="itinerary-timeline__flight-airline">
								{data.airlineName && (
									<span className="itinerary-timeline__airline-name">
										{data.airlineName}
									</span>
								)}
								{data.flightNumber && (
									<span className="itinerary-timeline__flight-number">
										{data.flightNumber}
									</span>
								)}
								{data.operatingAirlineName && (
									<div className="itinerary-timeline__flight-operator">
										<FormattedMessage
											values={{
												airline: data.operatingAirlineName,
											}}
											id="quotation.flight.flight.operator.label"
										/>
									</div>
								)}
							</div>
						</div>
					</>
				);
			case ITINERARY_INFO_TYPE.TRANSIT_INFO:
				return (
					<>
						<div className="itinerary-timeline__line--dashed" />
						<div className="itinerary-timeline__infos">
							<div className="itinerary-timeline__transit-detail">
								<FormattedMessage
									id="general.stop.duration"
									values={{
										value: convertDurationLabel(data.duration),
									}}
								/>
							</div>
						</div>
					</>
				);
			default:
				return "";
		}
	};

	return (
		<div className="itinerary-view">
			<div className="itinerary-view__flight-label">
				<FormattedMessage id={label} />
			</div>
			{flightData.length > 0 && (
				<div className="itinerary-timeline" data-testid="itinerary-timeline">
					{flightData.map(event => timelineComponentRender(event))}
				</div>
			)}
		</div>
	);
};

ItineraryView.propTypes = {
	label: PropTypes.string,
	flightData: PropTypes.array,
};

export default memo(ItineraryView);
